import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetReportsConfig } from 'domain/usecases';
import { RemoteGetReportsConfig } from 'data/usecases/reports/remote-get-reports-config';

export const makeRemoteGetReportsConfig = (): GetReportsConfig => {
  return new RemoteGetReportsConfig(makeApiUrl('/reports/config'), makeAuthorizeHttpClientDecorator());
};
